<template>
	<div>
		<transition>
      <div class="w-100 fixed-top" v-show="action_success.show">
        <b-row class="justify-content-center" no-gutters>
          <b-col cols="12" sm="8" md="6" lg="4" xl="4">
            <div class="p-3 border mb-3 radius-0 text-center" style="background-color: rgb(243, 255, 249); border-color: rgb(184, 254, 205) !important;">
              <p class="mb-0 body-3-1">{{action_success.message}}</p>
            </div>  
          </b-col>
        </b-row>
      </div>
    </transition>
		<div class="w-100 text-center py-3 border-bottom">
			<p class="body-2 mb-1">{{$t('payment-result.payment-time')}}</p>
			<p class="heading-4-1 mb-0" v-if="timeout">00:00:00</p>
			<p v-else class="heading-4-1 mb-0">
				<template v-if="countdown.hours() < 10">
					0{{countdown.hours()}}:
				</template>
				<template v-else>
					{{countdown.hours()}}:
				</template>
				<template v-if="countdown.minutes() < 10">
					0{{countdown.minutes()}}:
				</template>
				<template v-else>
					{{countdown.minutes()}}:
				</template>
				<template v-if="countdown.seconds() < 10">
					0{{countdown.seconds()}}
				</template>
				<template v-else>
					{{countdown.seconds()}}
				</template>
			</p>
			<!-- <p class="body-3-3-1 mb-0">Sebelum Jumat, 24 Juli 2020, 17:25</p> -->
		</div>
		<div class="w-100 py-3 text-center border-bottom">
			<p class="body-3 mb-1">{{$t('payment-result.payment-paid')}}</p>
			<p class="body-2-4 text-orange mb-1">{{formatCurrency(data.tagihan)}}</p>
			<p class="body-3 mb-0 text-green cursor-pointer" @click="copyAmount">{{$t('payment-result.copy-quantity')}}</p>
		</div>
		<div class="w-100 py-3 text-center">
			<p class="body-3 mb-2">{{$t('payment-result.payment-via-bank-bpd')}}</p>
			<div class="w-100 mb-1 border-bottom text-center" v-if="channel == 'VA_ATM_BERSAMA'">
				<p class="mx-1 mb-0 py-2 d-inline-block align-middle cursor-pointer" @click="showHideData('atm_bersama')" :class="{'body-2-2-3 text-green tab-active': toggle_data == 'atm_bersama', 'body-2-1' : toggle_data != 'atm_bersama'}">
					{{$t('payment-result.atm-bersama')}}
				</p>
				<p class="mx-1 mb-0 py-2 d-inline-block align-middle cursor-pointer" @click="showHideData('ebanking')" :class="{'body-2-2-3 text-green tab-active': toggle_data == 'ebanking', 'body-2-1' : toggle_data != 'ebanking'}">
					{{$t('payment-result.other-e-banking')}}
				</p>
				<p class="mx-1 mb-0 py-2 d-inline-block align-middle cursor-pointer" @click="showHideData('bpd')" :class="{'body-2-2-3 text-green tab-active': toggle_data == 'bpd', 'body-2-1' : toggle_data != 'bpd'}">
					{{$t('payment-result.bpd-bali')}}
				</p>
				<!-- <div class="text-center">
            <button class="btn btn-outline-secondary body-3 text-14">BPD Bali</button>
            <button class="btn btn-outline-secondary body-3 text-14">ATM Bersama</button>
            <button class="btn btn-outline-secondary body-3 text-14">E-Banking Lain</button>
        </div> -->

				<!-- <img @click="testConsole()" src="../../assets/img/icon/logo-bpd.png" class="d-inline-block align-middle mr-2" height="30">
				<p class="sub-heading-1-2 mb-0 d-inline-block align-middle" style="letter-spacing: 2px !important;">{{data.va}}</p> -->
			</div>
			<div class="w-100 p-2" v-if="toggle_data == 'bpd'">
				<div class="w-100 mb-3 pb-3 border-bottom">
					<img src="../../assets/img/icon/logo-bpd.png" class="mb-2" height="100">
					<p class="body-3 mb-0">{{$t('payment-result.billing-number')}}</p>
					<p class="sub-heading-1-2 mb-0" style="letter-spacing: 2px !important;">{{data.va_bpd_bali}}</p>
				</div>
				<div class=" text-left">
					<p class="body-2-4 mb-2">{{$t('payment-result.payment-guide')}}</p>
					<ol class="pl-0 body-2-2 ml-4 mb-0">
						<li>{{$t('bpd.enter-username-password')}}</li>
						<li>{{$t('payment-result.select-menu')}} <strong>“{{$t('payment-result.payment')}}”</strong></li>
						<li>{{$t('payment-result.choose')}} <strong>“{{$t('payment-result.e-commerce')}}”</strong></li>
						<li>{{$t('bpd.select-input-id-number')}} <strong>“{{$t('payment-result.virtual-account')}} {{getMerchant().name}} - {{$t('payment-result.bpd-bali')}}”</strong></li>
						<li>{{$t('bpd.input-bill-number')}} <strong>{{data.va_bpd_bali}}</strong></li>
						<li>{{$t('bpd.input-pin-to-continue-transaction')}}.</li>
						<li>{{$t('payment-result.finished')}}.</li>
					</ol>
				</div>
			</div>
			<div class="w-100 p-2" v-if="toggle_data == 'atm_bersama'">
				<div class="w-100 mb-3 pb-3 border-bottom">
					<img src="../../assets/img/icon/atm-bersama.jpg" class="mb-2" height="100">
					<p class="body-3 mb-0">{{$t('payment-result.virtual-account-number')}}</p>
					<p class="sub-heading-1-2 mb-0" style="letter-spacing: 2px !important;">{{data.va_atm_bersama}}</p>
				</div>
				<div class=" text-left">
					<p class="body-2-4 mb-2">{{$t('payment-result.payment-guide')}}</p>
					<ol class="pl-0 body-2-2 ml-4 mb-0">
						<li>{{$t('atm.select-language')}}</li>
						<li>{{$t('atm.enter-pin')}}</li>
						<li>{{$t('payment-result.choose')}} <strong>“{{$t('atm.other-transactions')}}”</strong></li>
						<li>{{$t('payment-result.choose')}} <strong>“{{$t('payment-result.payment')}}”</strong></li>
						<li>{{$t('payment-result.choose')}} <strong>“{{$t('atm.to-another-bank')}}”</strong></li>
						<li>{{$t('atm.enter-the-account-number')}} <strong>{{data.va_atm_bersama}}</strong>, {{$t('payment-result.then-press')}} <strong>“{{$t('payment-result.correct')}}”</strong></li>
						<li>{{$t('atm.please-fill-or-empty')}} <strong>“{{$t('payment-result.correct')}}”</strong></li>
						<li>{{$t('atm.the-transfer-confirmation')}},</li>
						<li>{{$t('atm.if-true')}}, {{$t('payment-result.then-press')}} <strong>“{{$t('payment-result.correct')}}”</strong>.</li>
						<li>{{$t('payment-result.finished')}}</li>
					</ol>
				</div>
			</div>
			<div class="w-100 p-2" v-if="toggle_data == 'ebanking'">
				<div class="w-100 mb-3 pb-3 border-bottom">
					<img src="../../assets/img/icon/bank-transfer.png" class="mb-2" height="100">
					<p class="body-3 mb-0">{{$t('payment-result.virtual-account-number')}}</p>
					<p class="sub-heading-1-2 mb-0" style="letter-spacing: 2px !important;">{{data.va_ebanking}}</p>
				</div>
				<div class=" text-left">
					<p class="body-2-4 mb-2">{{$t('payment-result.payment-guide')}}</p>
					<ol class="pl-0 body-2-2 ml-4 mb-0">
						<li>{{$t('ebanking.login-to')}}</li>
						<li>{{$t('payment-result.select-menu')}} <strong>“{{$t('payment-result.transfer')}}”</strong></li>
						<li>{{$t('payment-result.select-menu')}} <strong>“{{$t('ebanking.interbank-transfer')}}”</strong></li>
						<li>{{$t('ebanking.select-destination-bank')}} <strong>“{{$t('payment-result.bank-bpd-bali')}}”</strong></li>
						<li>{{$t('atm.enter-the-account-number')}} <strong>{{data.va_ebanking}}</strong></li>
						<li>{{$t('ebanking.enter-the-nominal')}} <strong>"{{$t('payment-result.correct')}}"</strong></li>
						<li>{{$t('atm.the-transfer-confirmation')}}</li>
						<li>{{$t('ebanking.enter-password-or-pin')}}</li>
						<li>{{$t('payment-result.finished')}}</li>
					</ol>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {mapGetters} from 'vuex'
	import {formatCurrency,formatDate} from '@/utils/index.js'
	import moment from 'moment';
	export default{
		props:['data','channel','tx_date','type'],
		data(){
			return{
				toggle_data: 'bpd',
	      countdown: moment(),
	      timeout: false,
				action_success:{
          show: false,
          message: '',
          timer: 0
        }
			}
		},
		computed:{
			show_success(){
        return this.action_success.show
      }
		},
		watch:{
			show_success(){
        if (this.action_success.show) {
          let looping = setInterval(() => {
            if (this.action_success.timer > 0) {
              this.action_success.timer--
            }else if(this.action_success.timer == 0){
              this.action_success.show = false
              this.action_success.message = ''
              clearInterval(looping)
            }
          },1000) 
        }
      }
		},
		mounted() {
      let testDateUtc = (this.type == 'hotel') ? this.tx_date : moment.utc(this.tx_date);
      let localDate = moment(testDateUtc);
      let localDate_1 = moment(testDateUtc);

      let current_formatted = moment().format("YYYY-MM-DD HH:mm:ss")
      // let current_formatted = moment().format('HH:mm:ss')
      // let current = moment(current_formatted, "HH:mm:ss")
      let created_at_formatted = moment(localDate).add(24,'h')
      let created_at = moment(created_at_formatted).format("YYYY-MM-DD HH:mm:ss")
      console.log("asli :",moment(localDate).format("YYYY-MM-DD HH:mm:ss"))
      console.log("+24 :",moment(created_at).format("YYYY-MM-DD HH:mm:ss"))
      console.log("now :",moment(current_formatted).format("YYYY-MM-DD HH:mm:ss"))
      // console.log("durasi : ",moment.duration(created_at.diff(moment(current_formatted))))
      console.log("diff : ",moment(created_at).diff(moment(current_formatted), 'hours',true))
      this.countdown = moment.duration(moment(created_at).diff(moment(current_formatted)))

      let looping = setInterval(() => {
          this.countdown = this.countdown.subtract(1, 'seconds')
        if (this.countdown.hours() <= 0 && this.countdown.minutes() <= 0 && this.countdown.seconds() <= 0) {
          clearInterval(looping)
          this.timeout = true
        }
        },1000)
		},
		created(){
			if (this.channel == 'VA_ATM_BERSAMA') {
				this.toggle_data = 'atm_bersama'
			}
		},
		methods: {
			...mapGetters(['getTicketPayment','getMerchant']),
			formatDate(date){
        return formatDate(date);
      },
      formatCurrency(value){
        return formatCurrency(value);
      },
      testConsole(){
      	console.log("payment : ", this.getTicketPayment())
      },
      showHideData(data){
      	if (this.toggle_data == data) {
	 				this.toggle_data = ''
	 			}else{
	 				this.toggle_data = data
	 			}
      },
      copyAmount(){
        var value = parseFloat(this.data.tagihan);
        var input_temp = document.createElement("input");
        input_temp.value = value;
        document.body.appendChild(input_temp);
        input_temp.select();
        document.execCommand("copy");
        document.body.removeChild(input_temp);
        this.action_success.show = true
        this.action_success.message = this.$t('payment-result.total-bill-copy')
        this.action_success.timer = 2
      }
		}
	}
</script>
<style scoped>
	.rotate-180{
		transform: rotate(180deg);
	}
	.tab-active{
		border-bottom: 2px solid #79a33a;
	}
</style>


// WEBPACK FOOTER //
// src/components/hotel/VirtualAccountForm.vue